import DataGrid, { Column } from 'devextreme-react/data-grid';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Confirm } from 'semantic-ui-react';
import { financeHelperApi } from "../../../api/finance/financeHelperApi";
import { DangerButton, DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import EditTBTPKhoanNop from './edit_tbtp_khoannop';
import styles from './TinhBaoPhi.module.css'
import SendEmailModal from './send-email/SendEmailModal';

const TinhBaoPhi = ({ hocSinh, height }) => {
	// const { nam_hoc } = useSelector(x => x.namHoc);
	const { canAccessTo, translate } = useCommonContext();
	const [filter, setFilter] = useState({ ts_hocsinh_id: 0, nam_hoc: '' });
	const [tinhBaoPhi, setTinhBaoPhi] = useState([]);
	const [sf_tinhbaophi_id_delete, set_sf_tinhbaophi_id_delete] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const grid = useRef(null);
	const { dm_coso_id } = useSelector(x => x.coSo);
	const [isShowDetailModal, setIsShowDetailModal] = useState(false);
	const [isShowDeleteConfirm, setIsShowDeleteConfirm] = useState(false);
	const [sf_tinhbaophi_edit, set_sf_tinhbaophi_edit] = useState([]);
	const [isShowSendEmailModal, setIsShowSendEmailModal] = useState(false);

	const componentDidMount = useRef(false);
	const handleReloadData = async () => {
		setIsLoading(true)
		const datasend = { ts_hocsinh_id: hocSinh.id, nam_hoc: hocSinh.nam_hoc }
		const res = await financeHelperApi.sf_tinhbaophi_selectbyhocsinh(datasend);
		if (!componentDidMount.current) return;
		setIsLoading(false)
		if (res.is_success) {
			setTinhBaoPhi(res.data.data);
		} else {
			setTinhBaoPhi([]);
		}
	};
	useEffect(() => {
		if (isLoading) {
			grid.current.instance.beginCustomLoading();
		} else {
			grid.current.instance.endCustomLoading();
		}
	}, [isLoading]);
	const handleDelete = async () => {
		setIsLoading(true)
		const datasend = { sf_tinhbaophi_id: sf_tinhbaophi_id_delete, dm_coso_id: dm_coso_id }
		const res = await financeHelperApi.sf_tinhbaophi_delete(datasend);
		if (!componentDidMount.current) return;
		setIsLoading(false)
		if (res.is_success) {
			handleReloadData({ ...filter });
			setIsShowDeleteConfirm(false);
			showNotify({ type: 'success', text: translate('Xóa báo phí thành công.') });
		} else {
			showNotify({
				type: 'error',
				text: 'Có lỗi xảy ra',
			});
		}
	};
	const btnSendEmail_Click = (data) => {
		setIsShowSendEmailModal(true);
	}
	const commandCellRender = (cell) => {
		return (
			<div>
				<span
					style={{ cursor: 'pointer' }}
					onClick={() => {
						set_sf_tinhbaophi_edit(cell.data)
						setIsShowDetailModal(true);

					}}
				>
					<i aria-hidden='true' className='icon edit'></i>{' '}
				</span>
				<span
					style={{ cursor: 'pointer' }}
					onClick={() => {
						setIsShowDeleteConfirm(true);
						set_sf_tinhbaophi_id_delete(cell.data.id)
					}}
				>
					<i aria-hidden='true' className='icon trash'></i>{' '}
				</span>
				<span
					style={{ cursor: 'pointer', color: 'green' }}
					onClick={() => {
						set_sf_tinhbaophi_edit(cell.data)
						btnSendEmail_Click();
					}}
				>
					<i aria-hidden="true" className="icon send"></i>{' '}
				</span>
			</div>
		);
	};

	useEffect(() => {
		if (hocSinh) {
			setFilter({ ts_hocsinh_id: hocSinh.id, nam_hoc: hocSinh.nam_hoc });
		}
	}, [hocSinh]);

	useEffect(() => {
		componentDidMount.current = true;
		if (filter && filter.ts_hocsinh_id > 0 && filter.nam_hoc) {
			handleReloadData({ ts_hocsinh_id: filter.ts_hocsinh_id, nam_hoc: filter.nam_hoc });
		}
		return () => {
			componentDidMount.current = false;
		};
	}, [filter]);

	return (
		<div>
			<div className='row'>
				<div className='col-md-12 padding-top-1rem'>
					<Toolbar className='bg-background'>
						<Item
							location='before'
							render={() => {
								return <h3>{translate('Danh sách báo phí')}</h3>;
							}}
						/>
						<Item
							location='after'
							render={() => {
								return (
									<DefaultButton
										text={translate('Tải lại dữ liệu')}
										icon={'fas fa-sync-alt'}
										onClick={() => {
											handleReloadData();
										}}
									/>
								);
							}}
						/>
						<Item
							location='after'
							render={() => {
								return (
									<PrimaryButton
										text={translate('Thêm báo phí')}
										icon={'fas fa-plus'}
										onClick={() => {
											set_sf_tinhbaophi_edit([])
											setIsShowDetailModal(true);
										}}
									/>
								);
							}}
						/>
					</Toolbar>
				</div>
				<div className='col-md-12'>
					<DataGrid
						keyExpr='id'
						ref={grid}
						dataSource={tinhBaoPhi}
						columnHidingEnabled={true}
						columnAutoWidth={true}
						showBorders={true}
						showColumnLines={true}
						showRowLines={true}
						rowAlternationEnabled={true}
						allowColumnResizing={true}
						columnResizingMode={'nextColumn'}
						hoverStateEnabled={true}
						focusedRowEnabled={false}
					// height={window.innerHeight - 150}
					>
						<Column
							visibleIndex={0}
							caption={'#'}
							cellRender={(cell) => <span>{cell.rowIndex + 1}</span>}
							width={40}
							alignment='center'
						/>
						<Column
							alignment='center'
							cellRender={commandCellRender}
							caption={translate('Thao tác')}
							width={85}
						></Column>
						<Column minWidth={200} alignment='center' caption={translate('Nội dung')} dataField='noi_dung' />
						<Column caption={"File"} alignment="center" width={100} cellRender={cell => {
							if (cell.data.pdf_file) {
								return <a href={cell.data.pdf_file} target="_blank">
									<i className="fas fa-file-pdf"></i>
								</a>
							}
							return <></>
						}} />,
						<Column caption={translate("Ngày gửi")} dataField="send_time" format={"dd/MM/yyyy"} dataType={"date"} width={100}></Column>,
						<Column caption={translate("Người gửi")} dataField="send_user" width={100}></Column>,
					</DataGrid>
				</div>
				{isShowDetailModal && (
					<EditTBTPKhoanNop
						sf_tinhbaophi_viewmodel={sf_tinhbaophi_edit}
						hocSinh={hocSinh}
						onSelected={() => {
							setIsShowDetailModal(false);
							handleReloadData({ ...filter });
						}}
						onCancel={() => {
							handleReloadData({ ...filter });
							setIsShowDetailModal(false);
						}}
					/>

				)}
			</div>
			{isShowSendEmailModal && (
				<SendEmailModal
					ts_hocsinh={hocSinh}
					onSelected={() => {
						handleReloadData();
						setIsShowSendEmailModal(false);
					}}
					onCancel={() => {
						setIsShowSendEmailModal(false);
					}}
					sf_tinhbaophi_editing={sf_tinhbaophi_edit}

				/>

			)}
			{isShowDeleteConfirm && (
				<Confirm
					className={styles.modal_center}
					open={true}
					dimmer={'blurring'}
					header={translate('Lưu ý')}
					content={translate('Bạn có chắc chắn muốn xóa báo phí này?')}
					size='mini'
					cancelButton={() => {
						return (
							<DefaultButton
								text={'Đóng'}
								onClick={() => {
									setIsShowDeleteConfirm(false);
								}}
							/>
						);
					}}
					confirmButton={() => {
						return (
							<>
								<DangerButton
									text={translate('Xóa')}
									onClick={() => {
										handleDelete();
									}}
								/>
							</>
						);
					}}
				/>
			)}
		</div>
	);
};

export default TinhBaoPhi;
